import { useGetCurrentSDUIClientSize } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/Viewport/useGetCurrentSDUIClientSize";
export var useNumComponentsByClientSize = function(numberOfComponentsByClientSize) {
    var sduiClientSize = useGetCurrentSDUIClientSize();
    if (!numberOfComponentsByClientSize) {
        return Infinity;
    }
    return numberOfComponentsByClientSize[sduiClientSize];
};
